import { signOutFoxit } from "../apis/foxit";
import { getTeamsDataFromUrl } from "../utils/utils";
import { deleteFoxitTokenWithTeams } from "./token";

export async function signOutFoxitWithinTeams() {
    const { email } = getTeamsDataFromUrl();
    await signOutFoxit(email);
    deleteFoxitTokenWithTeams();
}
